import React from 'react';
import { Row, Col } from 'antd';
import CountCards from './CountCards';
import {
  PiStorefrontLight,
  PiDeviceMobileLight,
  PiCoinsLight,
  PiCheckCircleLight,
  PiClockLight,
  PiXCircleLight,
} from "react-icons/pi";

const TransactionCount = ({ showValues, dashboardStatistics }) => {
  return (
    <div className="transaction-count" style={{ marginBottom: '32px' }}>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} lg={4}>
          <CountCards
            countTitle="Users"
            countValue={dashboardStatistics?.totalRegisteredUser || 0}
            icon={<PiStorefrontLight />}
            showValues={showValues}
            premium
          />
        </Col>
        <Col xs={24} sm={12} lg={4}>
          <CountCards
            countTitle="Terminals"
            countValue={dashboardStatistics?.totalTerminalIssued || 0}
            icon={<PiDeviceMobileLight />}
            showValues={showValues}
          />
        </Col>
        <Col xs={24} sm={12} lg={4}>
          <CountCards
            countTitle="Acquired"
            countValue={dashboardStatistics?.totalRevenueAcquire || 0}
            icon={<PiCoinsLight />}
            showValues={showValues}
          />
        </Col>
        <Col xs={24} sm={12} lg={4}>
          <CountCards
            countTitle="Settled"
            countValue={dashboardStatistics?.totalRevenueSettled || 0}
            icon={<PiCheckCircleLight />}
            showValues={showValues}
          />
        </Col>
        <Col xs={24} sm={12} lg={4}>
          <CountCards
            countTitle="Pending"
            countValue={dashboardStatistics?.totalRevenuePending || 0}
            icon={<PiClockLight />}
            showValues={showValues}
          />
        </Col>
        <Col xs={24} sm={12} lg={4}>
          <CountCards
            countTitle="Refunded"
            countValue={dashboardStatistics?.totalRevenueRefunded || 0}
            icon={<PiXCircleLight />}
            showValues={showValues}
          />
        </Col>
      </Row>
    </div>
  );
};

export default TransactionCount;
